'use client';

import { useDrawer } from '@cat-ecom/pcc-components';
import { createContext, useContext, useMemo } from 'react';
import { DealerLocatorLoaderProvider } from './dealer-locator-loader-context';

type DealerLocatorDrawerProviderProps = {
  isStoreLocationListViewUpdateFlag?: boolean;
  isStoreLocationTandCFlag?: boolean;
  children: React.ReactNode;
};
type DealerLocatorDrawerContextType = ReturnType<typeof useDrawer> & {
  isStoreLocationListViewUpdateFlag?: boolean;
  isStoreLocationTandCFlag?: boolean;
};
const DealerLocatorDrawerContext =
  createContext<DealerLocatorDrawerContextType>(null);
export const useDealerLocatorDrawer = () =>
  useContext(DealerLocatorDrawerContext);

export const DealerLocatorDrawerProvider = ({
  children,
  isStoreLocationListViewUpdateFlag = false,
  isStoreLocationTandCFlag = false
}: DealerLocatorDrawerProviderProps) => {
  const dealerLocatorDrawer = useDrawer({ size: 'lg' });
  const dealerLocatorContextValue = useMemo(
    () => ({
      ...dealerLocatorDrawer,
      isStoreLocationListViewUpdateFlag,
      isStoreLocationTandCFlag
    }),
    [
      dealerLocatorDrawer,
      isStoreLocationListViewUpdateFlag,
      isStoreLocationTandCFlag
    ]
  );
  return (
    <DealerLocatorLoaderProvider>
      <DealerLocatorDrawerContext.Provider value={dealerLocatorContextValue}>
        {children}
      </DealerLocatorDrawerContext.Provider>
    </DealerLocatorLoaderProvider>
  );
};
